/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountPaginationResponseAllOfDataInner } from './AccountPaginationResponseAllOfDataInner';
import {
    AccountPaginationResponseAllOfDataInnerFromJSON,
    AccountPaginationResponseAllOfDataInnerFromJSONTyped,
    AccountPaginationResponseAllOfDataInnerToJSON,
    AccountPaginationResponseAllOfDataInnerToJSONTyped,
} from './AccountPaginationResponseAllOfDataInner';

/**
 * 
 * @export
 * @interface AccountPaginationResponse
 */
export interface AccountPaginationResponse {
    /**
     * 全体件数
     * @type {number}
     * @memberof AccountPaginationResponse
     */
    totalCount?: number;
    /**
     * 現在のページ番号
     * @type {number}
     * @memberof AccountPaginationResponse
     */
    page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof AccountPaginationResponse
     */
    count?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof AccountPaginationResponse
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<AccountPaginationResponseAllOfDataInner>}
     * @memberof AccountPaginationResponse
     */
    data: Array<AccountPaginationResponseAllOfDataInner>;
}

/**
 * Check if a given object implements the AccountPaginationResponse interface.
 */
export function instanceOfAccountPaginationResponse(value: object): value is AccountPaginationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AccountPaginationResponseFromJSON(json: any): AccountPaginationResponse {
    return AccountPaginationResponseFromJSONTyped(json, false);
}

export function AccountPaginationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountPaginationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'page': json['page'] == null ? undefined : json['page'],
        'count': json['count'] == null ? undefined : json['count'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'data': ((json['data'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerFromJSON)),
    };
}

export function AccountPaginationResponseToJSON(json: any): AccountPaginationResponse {
    return AccountPaginationResponseToJSONTyped(json, false);
}

export function AccountPaginationResponseToJSONTyped(value?: AccountPaginationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'page': value['page'],
        'count': value['count'],
        'totalPages': value['totalPages'],
        'data': ((value['data'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerToJSON)),
    };
}

